import React from 'react';
import { Follow } from 'src/shared/design-system/Icon';
import { Tooltip, TooltipColors } from 'src/shared/design-system/Tooltip';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import { UnfollowedText } from './consts';
import { useUnfollowTooltip } from './hooks';
import { Container } from './styles';
import { FollowButtonUnfollowTooltipProps } from './types';

export const FollowButtonTooltipWrapper: React.FC<React.PropsWithChildren<FollowButtonUnfollowTooltipProps>> = (
  props
) => {
  const { children, isFollowing, name } = props;
  const { containerStyle, contentLocation, isOpen, isSmallScreen, tooltipMaxWidth } = useUnfollowTooltip(isFollowing);
  return (
    <Tooltip
      content={
        <Container isSmallScreen={isSmallScreen}>
          {isSmallScreen && <Follow outline />}
          <VerticallyCenteredText>
            <span>
              {UnfollowedText} {name}
            </span>
          </VerticallyCenteredText>
        </Container>
      }
      containerStyle={containerStyle}
      contentLocation={contentLocation}
      tooltipColor={TooltipColors.RED}
      isOpen={isOpen}
      showArrow={false}
      showShadow
      tooltipMaxWidth={tooltipMaxWidth}>
      {children}
    </Tooltip>
  );
};
